import React from 'react'
import { Field, reduxForm, getFormValues } from 'redux-form'
import ReactTable from 'react-table'
import { connect } from 'react-redux'
import { Icon, Modal } from 'semantic-ui-react'

import { 
  TablePagination
} from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { columnsSearchPO } from '../../data'
import {
  fetchPOComplete,
  setSelectPO,
  clearSearchPO
} from 'ducks/contract'

import { FieldRow } from '../styled'
import { Cont } from './styled'

const ModalSelectPO = (props) => {
  const {
    poCompleteList,
    valueForm,
    change,
    // props
    isEdit = false,
    isCreate = false,
    isDetail = false,
    onSubmit=null,
    onClose=null
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = React.useState(userPageSize)

  React.useEffect(()=>{
    props.clearSearchPO()
  },[])

  return (
    <Modal
      size='tiny'
      open={true}
      header='Select Purchase Order'
      onClose={()=>onClose()}
      // actions={['Select','Close']}
      content={
        <Cont d={poCompleteList.data.length>0}>
          <FieldRow>
            <Field 
              name='poSearch' 
              label='PO No'
              type={type.textSearch}
              component={FieldInput}
              placeHolder='Doc No., Title'
              onEnterPass={(value)=>{
                if(value.trim().length>0){
                  props.fetchPOComplete({key:value,page:1,size:pageSize})
                }
              }}
              onSearchClick={(value)=>{
                if(value.trim().length>0){
                  props.fetchPOComplete({key:value,page:1,size:pageSize})
                }
              }}
              showSearch={true}
              hideLabel
              require
            />
          </FieldRow>
          <ReactTable
            columns={columnsSearchPO}
            data={poCompleteList.data}
            loading={poCompleteList.loading}
            defaultPageSize={userPageSize}
            noDataText='No Contract data'
            previousText={<Icon name='arrow alternate circle left'/>}
            nextText={<Icon name='arrow alternate circle right'/>}
            className='contractList'

            PaginationComponent={TablePagination}
            pages={Object.keys(poCompleteList).length>0?poCompleteList.totalPage:0}
            currentPage={Object.keys(poCompleteList).length>0?poCompleteList.page:0}
            onPageChange={(pageIndex) => {
              props.fetchPOComplete({key:valueForm.poSearch,page:pageIndex+1,size:pageSize})
            }}
            onPageSizeChange={(pageSize, pageIndex) => {
              setPageSize(pageSize)
              localStorage.setItem('userPageSize', pageSize)
              props.fetchPOComplete({key:valueForm.poSearch,page:pageIndex+1,size:pageSize})
            }}

            getTdProps={(state, rowInfo, column) => {
              return {
                onClick: (e, handleOriginal) => {
                  if(rowInfo){
                    props.setSelectPO(rowInfo.original)
                    onSubmit(rowInfo.original)
                  }
                  if (handleOriginal) {
                    handleOriginal()
                  }
                }
              }
            }}
          />
        </Cont>
      }
    />
  )
}
const mapStateToProps = (state, props) => {
  return ({
    valueForm: getFormValues('formContractSearchPO')(state),
    members: state.member.members,
    poCompleteList: state.contract.poCompleteList
  })
}

const mapDispatchToProps = {
  fetchPOComplete,
  setSelectPO,
  clearSearchPO
}

const contForm = reduxForm({
  form: 'formContractSearchPO',
  enableReinitialize: true,
})(ModalSelectPO)


export default connect(mapStateToProps, mapDispatchToProps)(contForm)